export const openWindow = (url, width, heigth) => {
    const top = (screen.availHeight - heigth) / 2;
    const left = (screen.availWidth - width) / 2;
    window.open(url, '_blank', `width=${width},height=${heigth},top=${top},left=${left}`);
};